import {DossierItemType} from "const/DossierItemType"

export default {
  list: {
    title: "Dossier",
    noData: "No dossier items found",

    type: {
      [DossierItemType.invoice]: "Invoice"
    }
  },

  note: {
    title: "Note",

    input: {
      subject: "Subject",
    },
  },

  api: {
    dossierNote: {
      id: {
        notNull: "Something went wrong, we don't know which note to delete",
      },
    },
  },
}
